<script>

import  Quiz  from "./Component/Quiz.svelte";

</script>

    <style>
        :global(body) {
          background: #524763;
        }
      
        h1 {
          color: white;
          text-align: center;
        }
      
        div {
          background: white;
          border-radius: 15px;
          padding: 40px;
        }
       
      </style>
    <h1>Music Quiz</h1>
    <div><Quiz /></div>
